import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../App";

const getAuthHeaders = () => {
  const token = localStorage.getItem("auth_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

const usePresignedUrl = () => {
  const [presignedLoading, setPresignedLoading] = useState(false);

  const openPresignedUrl = async ({ key, download = false, dealId = null }) => {
    if (!key) {
      toast.error("Document not available");
      return;
    }

    setPresignedLoading(true);
    try {
      const res = await axios.get(`${API}/deals/documents/presigned-url`, {
        params: {
          key,
          ...(download && { download }),
          ...(dealId && { deal_id: dealId }),
        },
        withCredentials: true,
        headers: getAuthHeaders(),
      });
      if (!res.data?.url) throw new Error("No URL returned");
      window.open(res.data.url, "_blank", "noopener,noreferrer");
    } catch {
      toast.error("Failed to load document");
    } finally {
      setPresignedLoading(false);
    }
  };

  return { openPresignedUrl, presignedLoading };
};

export default usePresignedUrl;
